import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center p-4"
}
const _hoisted_2 = { class: "relative min-w-full md:min-w-[500px] w-full max-w-lg h-[450px] md:h-[500px] rounded-[2rem] shadow-2xl overflow-hidden transform transition-all border-4 border-white/10" }
const _hoisted_3 = { class: "absolute inset-0 z-0" }
const _hoisted_4 = { class: "relative h-full w-full" }
const _hoisted_5 = { class: "absolute inset-0 z-[10] flex flex-col items-center justify-center p-6 text-center" }
const _hoisted_6 = {
  key: 0,
  class: "bg-[#0B6A1F] text-white text-[11px] font-black uppercase tracking-[0.2em] px-5 py-2 rounded-full mb-6 shadow-2xl border border-white/20"
}
const _hoisted_7 = { class: "text-4xl md:text-5xl font-black text-white tracking-tighter leading-none mb-3 uppercase drop-shadow-[0_4px_15px_rgba(0,0,0,1)]" }
const _hoisted_8 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_9 = { class: "text-green-400" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_13 = {
  key: 2,
  class: "ml-2"
}
const _hoisted_14 = {
  key: 1,
  class: "text-white font-black text-[10px] md:text-xs uppercase tracking-[0.3em] mb-6 drop-shadow-[0_2px_8px_rgba(0,0,0,1)] opacity-90"
}
const _hoisted_15 = {
  key: 2,
  class: "text-white font-black text-[10px] md:text-xs uppercase tracking-[0.3em] mb-6 drop-shadow-[0_2px_8px_rgba(0,0,0,1)] opacity-90"
}
const _hoisted_16 = {
  key: 3,
  class: "flex items-center justify-center gap-2 md:gap-4 mb-6"
}
const _hoisted_17 = {
  key: 0,
  class: "bg-white/10 backdrop-blur-md rounded-2xl p-2 md:p-3 border border-white/10 flex flex-col items-center min-w-[80px] md:min-w-[100px]"
}
const _hoisted_18 = { class: "text-[8px] md:text-[10px] text-white font-bold leading-tight" }
const _hoisted_19 = {
  key: 1,
  class: "bg-white/10 backdrop-blur-md rounded-2xl p-2 md:p-3 border border-white/10 flex flex-col items-center min-w-[80px] md:min-w-[100px]"
}
const _hoisted_20 = { class: "text-[8px] md:text-[10px] text-white font-bold leading-tight" }
const _hoisted_21 = {
  key: 2,
  class: "bg-white/10 backdrop-blur-md rounded-2xl p-2 md:p-3 border border-white/10 flex flex-col items-center min-w-[80px] md:min-w-[100px]"
}
const _hoisted_22 = { class: "text-[8px] md:text-[10px] text-white font-bold leading-tight" }
const _hoisted_23 = { class: "w-full max-w-sm" }
const _hoisted_24 = { class: "flex flex-col md:flex-row items-center gap-3 bg-black/40 backdrop-blur-md p-2 rounded-2xl border border-white/20 shadow-2xl" }
const _hoisted_25 = { class: "flex-1 text-2xl font-mono font-black text-white tracking-[0.2em] pl-4" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}

import { ref, onMounted } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Pagination, Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import { useCoupon } from '@/composables/Coupon'


export default /*@__PURE__*/_defineComponent({
  __name: 'CouponModal',
  setup(__props) {

const isOpen = ref(false)
const promotions = ref<any[]>([])
const copiedCode = ref<string | null>(null)
const swiperModules = [Pagination, Navigation]

const { getPromotions } = useCoupon()

const initializeModal = async () => {
    // Determine if modal should open
    // We only open it on Home load and if promotions exist
    const res = await getPromotions()
    if (res.status === 'success' && res.data && res.data.length > 0) {
        promotions.value = res.data
        // Add a slight delay for better UX (so it pops after hero loads)
        setTimeout(() => {
            isOpen.value = true
        }, 1200)
    }
}

onMounted(() => {
    initializeModal()
})

const copyCode = async (code: string) => {
    try {
        await navigator.clipboard.writeText(code)
        copiedCode.value = code
        
        // Slightly longer delay to show the "COPIED" state then close
        setTimeout(() => {
            closeModal()
        }, 800)

        setTimeout(() => {
            if (copiedCode.value === code) {
                copiedCode.value = null
            }
        }, 2000)
    } catch (e) {
        console.error("Failed to copy", e)
    }
}

const closeModal = () => {
    isOpen.value = false
}

return (_ctx: any,_cache: any) => {
  return (isOpen.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity",
          onClick: closeModal
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Swiper), {
              modules: swiperModules,
              pagination: { clickable: true },
              navigation: promotions.value.length > 1,
              "slides-per-view": 1,
              class: "h-full coupon-swiper"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(promotions.value, (promo, index) => {
                  return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["absolute inset-0 z-0 bg-cover bg-center transition-transform duration-[3000ms] hover:scale-110", !promo.image_url ? 'bg-gradient-to-br from-[#1a1a1a] via-[#0a0a0a] to-black' : '']),
                          style: _normalizeStyle(promo.image_url ? { backgroundImage: `url(${promo.image_url})` } : {})
                        }, null, 6),
                        _createElementVNode("div", _hoisted_5, [
                          (promo.label_text)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(promo.label_text), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("h2", _hoisted_7, [
                            (promo.prefix_text)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(promo.prefix_text), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_9, [
                              (promo.discount_type === 'flat')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(promo.discount_value) + "$", 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(promo.discount_value) + "%", 1))
                            ]),
                            (promo.suffix_text)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(promo.suffix_text), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_13, "OFF"))
                          ]),
                          (promo.subtitle_text)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(promo.subtitle_text), 1))
                            : (_openBlock(), _createElementBlock("p", _hoisted_15, " FOR YOUR 1ST BOOKING ")),
                          (promo.feature_1_text || promo.feature_2_text || promo.feature_3_text)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                (promo.feature_1_text)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                      _cache[0] || (_cache[0] = _createElementVNode("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        class: "h-4 w-4 md:h-5 md:w-5 text-yellow-500 mb-1",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                        })
                                      ], -1)),
                                      _createElementVNode("span", _hoisted_18, _toDisplayString(promo.feature_1_text), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (promo.feature_2_text)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                      _cache[1] || (_cache[1] = _createElementVNode("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        class: "h-4 w-4 md:h-5 md:w-5 text-yellow-500 mb-1",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                                        })
                                      ], -1)),
                                      _createElementVNode("span", _hoisted_20, _toDisplayString(promo.feature_2_text), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (promo.feature_3_text)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                      _cache[2] || (_cache[2] = _createElementVNode("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        class: "h-4 w-4 md:h-5 md:w-5 text-yellow-500 mb-1",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.382-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                                        })
                                      ], -1)),
                                      _createElementVNode("span", _hoisted_22, _toDisplayString(promo.feature_3_text), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, _toDisplayString(promo.code), 1),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (copyCode(promo.code)),
                                class: "w-full md:w-auto px-8 py-3 bg-[#0B6A1F] hover:bg-green-700 text-white text-sm font-black rounded-xl shadow-2xl transition-all active:scale-90 flex items-center justify-center gap-2 border border-white/20"
                              }, [
                                (copiedCode.value === promo.code)
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_27, _cache[3] || (_cache[3] = [
                                      _createElementVNode("path", {
                                        "fill-rule": "evenodd",
                                        d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                                        "clip-rule": "evenodd"
                                      }, null, -1)
                                    ])))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", null, _toDisplayString(copiedCode.value === promo.code ? 'COPIED!' : 'COPY CODE'), 1)
                              ], 8, _hoisted_26)
                            ])
                          ]),
                          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mt-4 text-[10px] md:text-xs font-bold text-white uppercase tracking-widest opacity-80 drop-shadow-md" }, " Only for 1st time users ", -1))
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["navigation"])
          ]),
          _createElementVNode("button", {
            onClick: closeModal,
            class: "absolute top-6 right-6 z-[100] w-12 h-12 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 text-white transition-all backdrop-blur-xl border border-white/30 active:scale-90"
          }, _cache[5] || (_cache[5] = [
            _createElementVNode("span", { class: "sr-only" }, "Close", -1),
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              class: "h-6 w-6",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2.5",
                d: "M6 18L18 6M6 6l12 12"
              })
            ], -1)
          ]))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})